import React, { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from "recharts";
import { Users, IndianRupee, CheckCircle2, HelpCircle, AlertTriangle, Clock4 } from "lucide-react";
import api, { inr } from "../../lib/api";
import { Loading, PageHeader, StatCard } from "../../components/Shared";

const COLORS = ["#064E3B", "#C2410C", "#0369A1", "#B45309"];

export default function Reports() {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/admin/reports").then((x) => setR(x.data)).catch(() => setR({})); }, []);
  if (!r) return <Loading />;
  return (
    <div data-testid="admin-reports">
      <PageHeader title="Operational Reporting" sub="V1 essentials — subscriptions, visits, requests, utilisation and revenue." />
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-3">
        <StatCard icon={Users} label="Active subscriptions" value={r.active_subscriptions ?? 0} testid="rep-subs" />
        <StatCard icon={Users} label="Total families" value={r.total_families ?? 0} testid="rep-families" />
        <StatCard icon={CheckCircle2} label="Visit completion" value={`${r.visit_completion_rate ?? 0}%`} testid="rep-completion" />
        <StatCard icon={HelpCircle} label="Service requests" value={`${r.requests_completed ?? 0}/${r.requests_total ?? 0}`} testid="rep-requests" />
        <StatCard icon={AlertTriangle} label="Open incidents" value={r.open_incidents ?? 0} tone={r.open_incidents ? "amber" : "default"} testid="rep-incidents" />
        <StatCard icon={IndianRupee} label="Collected revenue" value={inr(r.subscription_revenue || 0)} testid="rep-revenue" />
      </div>
      <div className="mt-6 grid gap-6 lg:grid-cols-2">
        <div className="p1-card p-5">
          <h2 className="font-heading text-lg font-semibold text-stone-900">Subscriptions by plan (MRR)</h2>
          <div className="mt-4 h-64" data-testid="chart-plans">
            <ResponsiveContainer>
              <BarChart data={r.subscriptions_by_plan || []}>
                <XAxis dataKey="plan" tick={{ fontSize: 12 }} /><YAxis allowDecimals={false} />
                <Tooltip formatter={(v, name) => (name === "mrr" ? inr(v) : v)} />
                <Bar dataKey="count" fill="#064E3B" radius={[6, 6, 0, 0]} name="Subscriptions" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="p1-card p-5">
          <h2 className="font-heading text-lg font-semibold text-stone-900">Care Manager utilisation (visits)</h2>
          <div className="mt-4 h-64" data-testid="chart-util">
            <ResponsiveContainer>
              <PieChart>
                <Pie data={(r.care_manager_utilisation || []).map((c) => ({ name: c.name, value: c.visits_completed }))} dataKey="value" nameKey="name" outerRadius={90} label>
                  {(r.care_manager_utilisation || []).map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <p className="mt-2 flex items-center gap-1.5 text-xs text-stone-400"><Clock4 className="h-3.5 w-3.5" /> Response-time analytics arrive in Phase 2.</p>
        </div>
      </div>
    </div>
  );
}
